import { customQueryHook } from '@zoopla/apollo';
import type {
    GetUserProfileQuery,
    GetUserProfileQueryVariables
} from './getUserProfile.query.generated';
import { default as QUERY } from './getUserProfile.query';

export const useGetUserProfileQuery = customQueryHook<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
>(QUERY);
